import { WizardOptions } from '../utils/types';

export type ReactNativeWizardOptions = WizardOptions;
